module.exports = __webpack_public_path__ + "static/09-f33c87ab77e1094f588d7e2ffad7c824.jpg";